import { z } from 'zod';

import { StrictAddress } from '../Address';
import { PropertyId } from '../BrandedIds';
import { zodBrandedUuid } from '../utils/Zod';
import { BaseLoanEvent } from './BaseLoanEvent';

export const DeletePropertyAddressEvent = BaseLoanEvent.extend({
  type: z.literal('deletePropertyAddress'),
  propertyId: zodBrandedUuid<PropertyId>(),
  addressToDelete: StrictAddress,
});
export type DeletePropertyAddressEvent = z.infer<typeof DeletePropertyAddressEvent>;
